import { Controller } from "@hotwired/stimulus"
import { driver } from "driver.js"

export default class extends Controller {
  static values = {
    shouldStart: Boolean,
    kind: String,
    taskDefaultIssue: Boolean,
    projectsPath: String,
    isDemo: Boolean
  }

  connect() {
    // if (this.shouldStartValue && !this.hasShownInSession()) {
    //   switch (this.kindValue) {
    //     case 'task_new':
    //       this.startTaskNewTutorial()
    //       break
    //     case 'task_show':
    //       this.startTaskShowTutorial()
    //       break
    //     default:
    //       this.startTaskIndexTutorial()
    //   }
    // }
  }

  hasShownInSession() {
    // sessionStorageでこのセッション内で既に表示済みかチェック
    const key = `pitboard_tutorial_${this.kindValue}`
    return sessionStorage.getItem(key) === 'shown'
  }

  markAsShownInSession() {
    // sessionStorageに表示済みフラグを立てる
    const key = `pitboard_tutorial_${this.kindValue}`
    sessionStorage.setItem(key, 'shown')
  }

  startTaskIndexTutorial() {
    const steps = [
      {
        element: "#side_navbar_menu_task_list",
        popover: {
          title: "タスクリスト",
          description: "すべてのタスクを一覧表示する画面です。検索やフィルタリングで必要なタスクをすぐに見つけることができます。",
          side: "right",
          align: "start"
        }
      },
      {
        element: "#side_navbar_menu_assign_board",
        popover: {
          title: "アサインボード",
          description: "タスクをメンバーに割り当てる画面です。誰がどのタスクを担当するか、ドラッグ＆ドロップで簡単に管理できます。",
          side: "right",
          align: "start"
        }
      },
      {
        element: "#side_navbar_menu_progress_board",
        popover: {
          title: "進捗ボード",
          description: "タスクの進捗状況を視覚的に管理するカンバンボードです。「未着手」「進行中」「完了」などのステータスを一目で確認できます。",
          side: "right",
          align: "start"
        }
      }
    ]

    // デモモードでない場合のみスペース設定のステップを追加
    if (!this.isDemoValue) {
      steps.push({
        element: "#side_navbar_menu_setting",
        popover: {
          title: "スペースの設定",
          description: "プロジェクト、ラベル、進捗ステータスなどをカスタマイズできます。メンバーの招待もここから行います。",
          side: "right",
          align: "start"
        }
      })
    }

    steps.push({
      element: "#new_task_button",
      popover: {
        title: "最初のタスクを作成",
        description: "ここをクリックして、最初のタスクを作成してみましょう！",
        side: "bottom",
        align: "start"
      }
    })

    const driverObj = driver({
      showProgress: true,
      showButtons: ["next", "previous", "close"],
      steps: steps,
      nextBtnText: "次へ →",
      prevBtnText: "← 戻る",
      doneBtnText: "完了",
      progressText: "{{current}} / {{total}}",
      popoverClass: "driverjs-theme",
      onDestroyed: () => {
        // チュートリアル完了時の処理（必要に応じて）
      }
    })

    // 少し遅延させてDOMが完全に読み込まれるのを待つ
    setTimeout(() => {
      this.markAsShownInSession()
      driverObj.drive()
    }, 400)
  }

  startTaskNewTutorial() {
    const steps = [{
      element: "#new_task",
      popover: {
        title: "タスクの作成",
        description: "タスクのタイトルやプロジェクト、説明を入力します",
        side: "bottom",
        align: "start"
      }
    }]

    // task_defaultがissueの場合のみkindのステップを追加
    if (this.taskDefaultIssueValue) {
      steps.push({
        element: "#task_form_kind",
        popover: {
          title: "タスクの種類を選択",
          description: "実施が確定している作業は「タスク」、まだ検討中の課題や問題は「イシュー」として登録します",
          side: "bottom",
          align: "start"
        }
      })
    }

    steps.push(
      {
        element: "#task_form_project",
        popover: {
          title: "プロジェクトを選択",
          description: `タスクを分類するプロジェクトを選択します。新しいプロジェクトは<a href="${this.projectsPathValue}" target="_blank">設定画面</a>から追加できます`,
          side: "bottom",
          align: "start"
        }
      },
      {
        element: "#task_form_detail",
        popover: {
          title: "説明を記入",
          description: "タスクの詳しい内容や背景、手順などをマークダウン形式で記入できます。見出しや箇条書き、リンクも使用可能です",
          side: "top",
          align: "start"
        }
      }
    )

    const driverObj = driver({
      showProgress: true,
      showButtons: ["next", "previous", "close"],
      steps: steps,
      nextBtnText: "次へ →",
      prevBtnText: "← 戻る",
      doneBtnText: "完了",
      progressText: "{{current}} / {{total}}",
      popoverClass: "driverjs-theme",
      onDestroyed: () => {
        // チュートリアル完了時にタイトル入力欄にフォーカス
        const titleInput = document.querySelector("#task_name")
        if (titleInput) {
          titleInput.focus()
        }
      }
    })

    // 少し遅延させてDOMが完全に読み込まれるのを待つ
    setTimeout(() => {
      this.markAsShownInSession()
      driverObj.drive()
    }, 250)
  }

  startTaskShowTutorial() {
    const steps = [{
      element: "#side_page",
      popover: {
        title: "タスクの詳細",
        description: "作成されたタスクの詳細を確認します",
        side: "bottom",
        align: "start"
      }
    }]

    // イシューの場合は「タスクにする」ボタン、それ以外は操作エリア
    const isIssue = document.querySelector("#task_detail_to_confirmed")
    if (isIssue) {
      steps.push({
        element: "#task_detail_to_confirmed",
        popover: {
          title: "タスク登録",
          description: "実施が決定したイシューは、このボタンでタスクに変更します。タスクに変更すると、担当者の割り当てや進捗管理ができるようになります。",
          side: "bottom",
          align: "start"
        }
      })
    } else {
      const operations = document.querySelector("#task_detail_operations")
      if (operations) {
        steps.push({
          element: "#task_detail_operations",
          popover: {
            title: "タスクの操作",
            description: "ここで担当者の割り当て、タスクサイズの設定、進捗ステータスの更新ができます。クリックするとメニューが表示され、選択できます。",
            side: "bottom",
            align: "start"
          }
        })
      }
    }

    steps.push(
      {
        element: "#task_detail_url_copy",
        popover: {
          title: "URLの共有",
          description: "このボタンをクリックすると、タスクのURLをクリップボードにコピーできます。チームメンバーに共有する際に便利です。",
          side: "bottom",
          align: "end"
        }
      }
    )

    // アーカイブボタンがある場合のみ追加
    const archiveBtn = document.querySelector("#task_detail_archive")
    if (archiveBtn) {
      steps.push({
        element: "#task_detail_archive",
        popover: {
          title: "アーカイブ",
          description: "完了したタスクや不要になったタスクはアーカイブします。アーカイブしたタスクは一覧から非表示になりますが、後から参照できます。",
          side: "bottom",
          align: "end"
        }
      })
    }

    const driverObj = driver({
      showProgress: true,
      showButtons: ["next", "previous", "close"],
      steps: steps,
      nextBtnText: "次へ →",
      prevBtnText: "← 戻る",
      doneBtnText: "完了",
      progressText: "{{current}} / {{total}}",
      popoverClass: "driverjs-theme",
      onDestroyed: () => {
        // チュートリアル完了時の処理
      }
    })

    // 少し遅延させてDOMが完全に読み込まれるのを待つ
    setTimeout(() => {
      this.markAsShownInSession()
      driverObj.drive()
    }, 250)
  }
}